import React, { FunctionComponent } from "react";
import styles from "./BarList.module.scss";
import BarListBlockProps from "./BarListProps.interface";

import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import getTextAlignment from "helpers/getTextAlignment";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import setInViewClasses from "blocks/hooks/setInViewClasses";
import useAnchor from "blocks/hooks/useAnchor";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import BarCard from "./components/BarCard";

const BarList: FunctionComponent<BarListBlockProps> = (props): JSX.Element => {
  const wrapperClasses = getWrapperClasses(props.settings);
  const wrapperStyles = useWrapperStyles(props.settings);
  const { inViewElementRef, inViewClasses } = setInViewClasses(styles);

  const identifier = useAnchor(props.settings.anchorMenuLabel);
  const { splitClasses, splitStyles } = useSplitBackground(props);

  const headlineCaseClass = props.settings.headlineCase
    ? styles[`case_${props.settings.headlineCase}`]
    : undefined;

  if (props.settings?.headlineAlignment) {
    wrapperStyles["--headline-alignment"] = getTextAlignment(
      props.settings?.headlineAlignment
    );
  }

  return (
    <section
      className={combineClasses(styles.wrapper, ...wrapperClasses)}
      style={{ ...wrapperStyles, ...splitStyles }}
      id={identifier}
    >
      <div
        className={combineClasses(
          styles.container,
          ...splitClasses,
          inViewClasses
        )}
        ref={inViewElementRef}
      >
        {/* Headline */}
        {props.content.headline ? (
          <DynamicHeading
            key={`head_${props.contentUdi}`}
            className={combineClasses(styles.headline, headlineCaseClass)}
            text={props.content.headline}
            headlineSize={props.settings.headlineSize}
            headlineWeight={props.settings.headlineWeight}
          />
        ) : null}

         {/* Bar list */}
         {props.content.barList && props.content.barList.length > 0 ? (
          <div className={styles.list}>
            {props.content.barList.map((item: any, index: number) => {
                return (
                  <BarCard key={index} {...item} settings={props.settings} />
                )
            })}
          </div>
         ): null}

      </div>

      {props.settings.backgroundMedia?.[0] &&
      props.settings.backgroundMedia.length > 0 ? (
        <BackgroundMedia
          key={props.contentUdi}
          {...props.settings.backgroundMedia[0]}
        />
      ) : null}
    </section>
  );
};

export default BarList;
